import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "problem", label: "The Problem" },
    { id: "solution", label: "The Solution" },
    { id: "services", label: "Services" },
    { id: "advantage", label: "The Advantage" },
];

export default function Footer() {
    return (
        <footer data-testid="footer-section" className="relative border-t border-line bg-panel/40">
            <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <Logo />
                        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            By Thom Kriner LLC
                        </p>
                        <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400">
                            HITL.partners is founded by Thom Kriner — pairing Lean Six Sigma
                            process engineering, behavioral diagnostics, and digital adoption
                            expertise to engineer mission-critical AI–human workflows.
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            // Navigate
                        </div>
                        <ul className="mt-5 space-y-3">
                            {LINKS.map((l) => (
                                <li key={l.id}>
                                    <a
                                        href={`#${l.id}`}
                                        onClick={scrollToId(l.id)}
                                        className="text-sm text-slate-400 transition-colors hover:text-blaze"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            // Contact
                        </div>
                        <a
                            href="mailto:Info@thomkriner.com"
                            data-testid="footer-contact-email-link"
                            className="mt-5 inline-flex items-center gap-3 border border-line px-5 py-4 font-mono text-xs uppercase tracking-[0.15em] text-slate-200 transition-all duration-300 hover:border-blaze/60 hover:text-blaze"
                        >
                            <Mail className="h-4 w-4 text-blaze" />
                            Info@thomkriner.com
                        </a>
                        <div className="mt-6 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                            <span className="h-1.5 w-1.5 animate-blink bg-signal" />
                            System nominal
                        </div>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-line pt-8 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-600 sm:flex-row sm:items-center">
                    <span>© {new Date().getFullYear()} Thom Kriner LLC. All rights reserved.</span>
                    <span>AI handles the rule. Humans handle the exception.</span>
                </div>
            </div>
        </footer>
    );
}
